import { lazy, Suspense } from 'react';
import { Outlet, Route } from 'react-router-dom';

import Loading from '../../components/Loading';

const InfititLoaderComp = lazy(
  () =>
    import(
      /* webpackChunkName: "test" */ '../../pages/lab/infinit-loader/InfititLoaderComp'
    ),
);

const InfiniteScrollTest = lazy(
  () =>
    import(
      /* webpackChunkName: "test" */ '../../pages/lab/infinit-loader/InfiniteScrollTest'
    ),
);

const SvgCharts = lazy(
  () => import(/* webpackChunkName: "test" */ '../../pages/lab/SvgChatrs'),
);

const TestingReact18 = lazy(
  () => import(/* webpackChunkName: "test" */ '../../pages/lab/TestingReact18'),
);

const DrawAreaExperiment = lazy(
  () =>
    import(/* webpackChunkName: "test" */ '../../pages/lab/DrawAreaExperiment'),
);

const DrawTruckPathExperiment = lazy(
  () =>
    import(
      /* webpackChunkName: "test" */ '../../pages/lab/DrawTruckPathExperiment'
    ),
);
const WebrtcLiveCall = lazy(
  () => import(/* webpackChunkName: "test" */ '../../pages/lab/WebrtcLiveCall'),
);

const AverageTemperatureChartDemoPage = lazy(
  () =>
    import(
      /* webpackChunkName: "test" */ '../../pages/lab/AverageTemperatureChartDemoPage'
    ),
);

const BarChartGradientDemoPage = lazy(
  () =>
    import(
      /* webpackChunkName: "test" */ '../../pages/lab/BarChartGradientDemoPage'
    ),
);

const PowerUsageChartDemoPage = lazy(
  () =>
    import(
      /* webpackChunkName: "test" */ '../../pages/lab/PowerUsageChartDemoPage'
    ),
);

const TimeBaseLineChartDemoPage = lazy(
  () =>
    import(
      /* webpackChunkName: "test" */ '../../pages/lab/TimeBaseLineChartDemoPage'
    ),
);

const WaterLevelChartDemoPage = lazy(
  () =>
    import(
      /* webpackChunkName: "test" */ '../../pages/lab/WaterLevelChartDemoPage'
    ),
);

const StackedBarChartDemoPage = lazy(
  () =>
    import(
      /* webpackChunkName: "test" */ '../../pages/lab/StackedBarChartDemoPage'
    ),
);

const StrengthHistogramChartDemoPage = lazy(
  () =>
    import(
      /* webpackChunkName: "test" */ '../../pages/lab/StrengthHistogramChartDemoPage'
    ),
);

const MultiLineChartDemoPage = lazy(
  () =>
    import(
      /* webpackChunkName: "test" */ '../../pages/lab/MultiLineChartDemoPage'
    ),
);

const DasgasChartDemoPage = lazy(
  () =>
    import(
      /* webpackChunkName: "test" */ '../../pages/lab/DasgasChartDemoPage'
    ),
);

const DasairChartDemoPage = lazy(
  () =>
    import(
      /* webpackChunkName: "test" */ '../../pages/lab/DasairChartDemoPage'
    ),
);

export const labRouter = (
  <Route
    path="/lab"
    element={
      <Suspense fallback={<Loading />}>
        <Outlet />
      </Suspense>
    }
  >
    <Route path="infinite-loader" element={<InfititLoaderComp />} />
    <Route path="infinite-scroll-test" element={<InfiniteScrollTest />} />
    <Route path="svg-charts" element={<SvgCharts />} />
    <Route path="test-react-18" element={<TestingReact18 />} />
    <Route path="draw-path-truck" element={<DrawTruckPathExperiment />} />
    <Route path="draw-area" element={<DrawAreaExperiment />} />
    <Route path="webrtc-live-call" element={<WebrtcLiveCall />} />
    <Route
      path="average-temperature-chart-demo"
      element={<AverageTemperatureChartDemoPage />}
    />
    <Route
      path="bar-chart-gradient-demo"
      element={<BarChartGradientDemoPage />}
    />
    <Route
      path="power-usage-chart-demo"
      element={<PowerUsageChartDemoPage />}
    />
    <Route
      path="time-base-line-chart-demo"
      element={<TimeBaseLineChartDemoPage />}
    />
    <Route path="dasair-chart-demo" element={<DasairChartDemoPage />} />
    <Route path="dasgas-chart-demo" element={<DasgasChartDemoPage />} />
    <Route path="multi-line-chart-demo" element={<MultiLineChartDemoPage />} />
    <Route
      path="strength-histogram-chart-demo"
      element={<StrengthHistogramChartDemoPage />}
    />
    <Route
      path="stacked-bar-chart-demo"
      element={<StackedBarChartDemoPage />}
    />
    <Route
      path="water-level-chart-demo"
      element={<WaterLevelChartDemoPage />}
    />
  </Route>
);
